// third party
import * as yup from 'yup';
import { isDate, isValid } from 'date-fns';

export const SCHEDULE_TYPES = ['none', 'oneTime', 'daily', 'weekly', 'monthly', 'yearly', 'custom'];
export const RECURRING_TYPES = ['daily', 'weekly', 'monthly', 'yearly', 'custom'];

const validationSchema = (intl) =>
    yup.object().shape({
        enabled: yup.boolean().nullable(),
        scheduleType: yup
            .string()
            .oneOf(SCHEDULE_TYPES)
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmscheduletype-required' })),
        sendAt: yup
            .date()
            .transform((value, originalValue) => (originalValue === '' || originalValue === undefined ? null : value))
            .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmsendat-invalid' }))
            .nullable()
            .when('scheduleType', {
                is: 'oneTime',
                then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmsendat-required' }))
            }),
        recurrenceInterval: yup
            .number()
            .transform((value, originalValue) => {
                if (originalValue === '' || originalValue === undefined || originalValue === null) {
                    return null;
                }

                return value;
            })
            .nullable()
            .when('scheduleType', {
                is: (scheduleType) => RECURRING_TYPES.includes(scheduleType),
                then: (schema) => schema.positive(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmrecurrenceinterval-positive' }))
            }),
        sendTime: yup
            .date()
            .transform((value, originalValue) => (originalValue === '' || originalValue === undefined ? null : value))
            .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmsendtime-invalid' }))
            .nullable(),
        weekDays: yup
            .array()
            .of(
                yup
                    .number()
                    .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmweekday-invalid' }))
                    .min(1, intl.formatMessage({ id: 'ui-comp-formvalidation-alarmweekday-invalid' }))
                    .max(7, intl.formatMessage({ id: 'ui-comp-formvalidation-alarmweekday-invalid' }))
            )
            .when('scheduleType', {
                is: 'weekly',
                then: (schema) =>
                    schema
                        .min(1, intl.formatMessage({ id: 'ui-comp-formvalidation-alarmweekdays-atleastone' }))
                        .required(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmweekdays-required' }))
            })
            .nullable(),
        monthDay: yup
            .number()
            .transform((value, originalValue) => {
                if (originalValue === '' || originalValue === undefined || originalValue === null) {
                    return null;
                }

                return value;
            })
            .min(1, intl.formatMessage({ id: 'ui-comp-formvalidation-alarmmonthday-min', values: { minValue: 1 } }))
            .max(31, intl.formatMessage({ id: 'ui-comp-formvalidation-alarmmonthday-max', values: { maxValue: 31 } }))
            .nullable(),
        startsAt: yup
            .date()
            .transform((value, originalValue) => (originalValue === '' || originalValue === undefined ? null : value))
            .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmstartsat-invalid' }))
            .nullable()
            .when('scheduleType', {
                is: (scheduleType) => RECURRING_TYPES.includes(scheduleType),
                then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmstartsat-required' }))
            }),
        endsAt: yup
            .date()
            .transform((value, originalValue) => (originalValue === '' || originalValue === undefined ? null : value))
            .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-alarmendsat-invalid' }))
            .nullable()
            .when('startsAt', (startsAt, schema) => {
                if (isDate(startsAt) && isValid(startsAt)) {
                    return schema.min(startsAt, intl.formatMessage({ id: 'ui-comp-formvalidation-alarmendbeforestart' }));
                }

                return schema;
            })
            .nullable()
    });

export default validationSchema;
